export default "/images/09d3c8c845823da69874799b541fdd1d.avif";